const messages = {
  name: 'Credit Event Log |||| Credit Event Logs',
  fields: {
    costCenterName: 'Cost Center',
    account: 'Account',
    provider: 'Provider',
    applicationName: 'Application',
    channel: 'Channel',
    from: 'From',
    to: 'To',
    creditsConsumed: 'Credits Consumed',
    createdAt: 'Logged Date',
  },
  empty: 'No event logs yet',
  filters: {
    costCenterName: 'Cost Center',
    applicationName: 'Application',
    channel: 'Channel',
    from: 'Provider',
    to: 'To',
  },
  search: {
    placeholder: 'Search Message Logs',
  },
};

export default messages;
